import React, { memo, useMemo, useState, useEffect } from "react";
import Cards from "../components/Cards.tsx";
import HeaderCustomized from "../components/imgBackground/HeaderCustomized.js";

/** ======= IDs de lecturas por grado ======= */
const G12P_IDS = [
  "loscrayonesvalientes-a1b2c3d4e5f67890123456789abcdef0",
  "lacucharasorprendente-1234567890abcdef1234567890abcdef",
  "laaventuradelparquelimpio-7f3e2c1a4b6d4e8f9a0b1c2d3e4f5a6b",
  "intiyelvalle-3f5c8a2b9d4e6f7182a0b1c3d5e7f901",
  "elhuesobrilante-5a3c7e1d9f2b4a68c0d1e3f7a9b2c4d6"
];
const G12S_IDS = [
  "elcuadernoyelverdaderotesoro-fefc2d5416e34182ad632d14ea4deff2",
  "atenayladudainteligente-9b8f3a4c2d1e4f7ab6c5d8e9f0a1b2c3",
  "elsonidodelamemoria-3f5c8a9e1b4d4c7f8a2e9d6b1c0f4a7b",
  "escucharloquenosdiceelcuerpo-8c1f2a9d4e5b4a6c9d2e7f3a1b0c5d8e",
  "escuchardeverdad-4f8c1a2b3d6e7f8091a2b3c4d5e6f7a8"
];
const G34P_IDS = [
  "elmensajeenlabotella-7c2a9e4b1d3f6a8e0b5c9d2f4a7e1b3c",
  "eljardinenlaciudaddelfuturo-6b1f3a9d4c7e4b2fa8d5c1e9f3a7b6d2",
  "elmapadeltesoroverdadero-9c3b6a2d4f1e8b7c5a0d2e9f3c6b1a4e",
  "lapiedradelguardianandino-3f2a9c1e6b4d8f7a5c0e2b1d9a6f3c8e",
  "eldragonqueguardabaelequilibrio-8b1c2d3e4f5a69788766554433221100"
];
const G34S_IDS = [
  "losapusylamiradacritica-3f5a8c2b6d4e4f1a9b7c8d2e6f9a1b3c",
  "ellenguajedelconflicto-4e7c2a9b1d6f43a8b5c1e9d2f7a3c6b1",
  "familiaycomunidadcomoespaciosdeidentidad-1a2b3c4d5e6f4789a1b2c3d4e5f67890",
  "ellibroquenaderecordaba-9f1a2b3c4d5e6789a0b1c2d3e4f56789",
  "eldiaqueeltiemposedetuvo-6c4a8f1d2b3e4970a5c6d7e8f9a1b2c3"
];
const G56P_IDS = [
  "lamaquinaquesabiaescucharalatierra-4d8a7c1e2b9f4a63b5c7d1e8f2a6c9b3",
  "lafiestadevariasvoces-7c1e4d2a9b3f4c8e8a6d2f5b1c9e3a77",
  "ellibroquereflejaba-2f4c8a91b6e347d9ac5f1e2837b64d0a",
  "huellasqueenseanan-9f3c2a1b4d6e4f7a8b9c0d1e2f3a4b5c",
  "lasmarcasdelasdecisiones-6b6c6d7e9b2f4a8c9d3e1f2a7c8b9d0e"
];

const G5S_IDS = [
  "cuandolosdatosnoobedecen-9f3c2a7b1d4e4c6a8b2d5e7f1a9c3b6d",
  "hipotesissobreunomismo-3d8f1a6c4b2e4978a5c9d1e6f7b3a2c4",
  "mentirseaunomismo-7a2c5e9d4b1f4a6c8d3e2f9b6a1c5d7e",
  "familiaycomunidadcomoespaciosdeidentidad-1a2b3c4d5e6f4789a1b2c3d4e5f67890",
  "ellenguajedelconflicto-4e7c2a9b1d6f43a8b5c1e9d2f7a3c6b1"
];

/** ======= Configuración dinámica de tests =======
 * Reglas:
 * - zoneinfo: string | string[] | "*"
 * - colegio: string | string[] | "*"
 * - categoria: "ALUMNO" | "DOCENTE" | "*" | array
 * - grados: [3,4] | "*" | { min, max }
 * - canSeeAllSections: permite ver todos los grupos activos
 */
const TEST_GROUPS = [
  {
    id: "primaria-asuncion-estudiantes",
    label: "PRIMARIA — 1° y 2°",
    description: "Evaluación para estudiantes de primaria",
    zoneinfo: "ASUNCION",
    colegio: ["AMIGUITOS DE ALAMEDA","86342 PEDRO KOCHATZIN"],
    categoria: "ALUMNO",
    grados: [2],
    startUtc: "2026-04-09T13:00:00Z",
    endUtc: "2026-04-09T20:30:00Z",
    lecturas: G12P_IDS,
    tematica: "#Evaluación Primaria",
  },
  {
    id: "secundaria-asuncion-estudiantes",
    label: "SECUNDARIA — 1° y 2°",
    description: "Evaluación para estudiantes de secundaria",
    zoneinfo: "ASUNCION",
    colegio: ["AMAUTA ATUSPARIA","86344 JAVIER HERAUD PEREZ"],
    categoria: "ALUMNO",
    grados: [7, 8],
    startUtc: "2026-04-09T13:00:00Z",
    endUtc: "2026-04-09T20:30:00Z",
    lecturas: G12S_IDS,
    tematica: "#Evaluación Secundaria",
  },
  {
    id: "primaria-asuncion-estudiantes",
    label: "PRIMARIA — 3° y 4°",
    description: "Evaluación para estudiantes de primaria",
    zoneinfo: "ASUNCION",
    colegio: "86339 MAESTRO UGO DE CENSI",
    categoria: "ALUMNO",
    grados: [3, 4],
    startUtc: "2026-04-09T13:00:00Z",
    endUtc: "2026-04-09T20:30:00Z",
    lecturas: G34P_IDS,
    tematica: "#Evaluación Primaria",
  },
  {
    id: "primaria-asuncion-estudiantes",
    label: "PRIMARIA — 5° y 6°",
    description: "Evaluación para estudiantes de primaria",
    zoneinfo: "ASUNCION",
    colegio: "*",
    categoria: "ALUMNO",
    grados: [5, 6],
    startUtc: "2026-04-09T13:00:00Z",
    endUtc: "2026-04-09T20:30:00Z",
    lecturas: G56P_IDS,
    tematica: "#Evaluación Primaria",
  },
  {
    id: "secundaria-asuncion-estudiantes",
    label: "SECUNDARIA — 5°",
    description: "Evaluación para estudiantes de secundaria",
    zoneinfo: "ASUNCION",
    colegio: "*",
    categoria: "ALUMNO",
    grados: [11],
    startUtc: "2026-04-09T13:00:00Z",
    endUtc: "2026-04-09T20:30:00Z",
    lecturas: G5S_IDS,
    tematica: "#Evaluación Secundaria",
  },
  {
    id: "primaria-asuncion-docentes",
    label: "DOCENTES — PRIMARIA",
    description: "Visualización para docentes de primaria",
    zoneinfo: "ASUNCION",
    colegio: "*",
    categoria: "DOCENTE",
    grados: { min: 1, max: 6 },
    startUtc: "2026-04-09T13:00:00Z",
    endUtc: "2026-04-09T20:30:00Z",
    lecturas: [...G12P_IDS, ...G34P_IDS,...G56P_IDS],
    tematica: "#Evaluación Primaria",
  },
  {
    id: "secundaria-asuncion-docentes",
    label: "DOCENTES — SECUNDARIA",
    description: "Visualización para docentes de secundaria",
    zoneinfo: "ASUNCION",
    colegio: "*",
    categoria: "DOCENTE",
    grados: { min: 7, max: 20 },
    startUtc: "2026-04-09T13:00:00Z",
    endUtc: "2026-04-09T20:30:00Z",
    lecturas: [...G12S_IDS,...G34S_IDS, ...G5S_IDS],
    tematica: "#Evaluación Secundaria",
  },
  {
    id: "ugel-asuncion-admin",
    label: "UGEL ASUNCIÓN",
    description: "Visualización total de grupos",
    zoneinfo: "*",
    colegio: "UGEL ASUNCION",
    categoria: "*",
    grados: "*",
    startUtc: "2026-04-09T13:00:00Z",
    endUtc: "2026-04-09T20:30:00Z",
    lecturas: [...G12P_IDS, ...G34P_IDS,...G56P_IDS, ...G12S_IDS,...G34S_IDS, ...G5S_IDS],
    tematica: "#Evaluación General",
    canSeeAllSections: true,
  },

  /** EJEMPLO de colegio específico
  {
    id: "colegio-especial-primaria",
    label: "COLEGIO ESPECIAL — PRIMARIA",
    description: "Test para un colegio puntual",
    zoneinfo: "*",
    colegio: "86339 MAESTRO UGO DE CENSI",
    categoria: "ALUMNO",
    grados: [3, 4],
    startUtc: "2026-04-10T13:00:00Z",
    endUtc: "2026-04-10T18:00:00Z",
    lecturas: G4_IDS,
    tematica: "#Evaluación Primaria",
  },
  */
];

/** ======= Utilitarios ======= */
const getCategoryStyles = (category) => {
  switch (category) {
    case "alumno":
      return {
        titleBg: "bg-gradient-to-t from-purple-700 to-transparent",
        borderColor: "border-purple-500",
        textColor: "text-white",
      };
    case "docente":
      return {
        titleBg: "bg-gradient-to-t from-orange-700 to-transparent",
        borderColor: "border-orange-500",
        textColor: "text-white",
      };
    case "plataforma":
      return {
        titleBg: "bg-black bg-opacity-50",
        borderColor: "border-transparent",
        textColor: "text-white",
      };
    default:
      return {
        titleBg: "bg-gradient-to-t from-gray-700 to-transparent",
        borderColor: "border-gray-500",
        textColor: "text-white",
      };
  }
};

const prettifyFromId = (id) => {
  const base = id.split("-")[0].replace(/[^a-zA-Z0-9]/g, " ");
  return base
    .split(" ")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

const idsToItems = (ids, tematica = "#Evaluación") =>
  ids.map((id) => ({
    id,
    titulo: prettifyFromId(id),
    tematica,
    creator_alias: "@sumaqt.willkarumi_.sw",
  }));

function formatDateLima(d) {
  return new Intl.DateTimeFormat("es-PE", {
    timeZone: "America/Lima",
    year: "numeric",
    month: "long",
    day: "2-digit",
  }).format(d);
}

function formatTimeLima(d) {
  return new Intl.DateTimeFormat("es-PE", {
    timeZone: "America/Lima",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(d);
}

function normalizeValue(v) {
  return String(v || "").trim().toUpperCase();
}

function matchField(rule, value) {
  if (rule === "*") return true;

  if (Array.isArray(rule)) {
    return rule.map(normalizeValue).includes(normalizeValue(value));
  }

  return normalizeValue(rule) === normalizeValue(value);
}

function matchGrados(rule, grado) {
  if (rule === "*") return true;

  if (Array.isArray(rule)) {
    return rule.includes(grado);
  }

  if (typeof rule === "object" && rule !== null) {
    const min = rule.min ?? -Infinity;
    const max = rule.max ?? Infinity;
    return grado >= min && grado <= max;
  }

  return false;
}

function matchGroup(group, userCtx) {
  return (
    matchField(group.zoneinfo, userCtx.zoneinfo) &&
    matchField(group.colegio, userCtx.colegio) &&
    matchField(group.categoria, userCtx.categoria) &&
    matchGrados(group.grados, userCtx.grado)
  );
}

/** ======= Banner de Test ======= */
function TestBanner({ endUtc, cohortLabel }) {
  const [closed, setClosed] = useState(false);
  if (closed) return null;

  const todayLima = new Date();
  const endLima = new Date(endUtc);

  return (
    <div className="mx-3 my-3 rounded-xl border border-emerald-200 bg-emerald-50/70 p-4 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="shrink-0 rounded-lg bg-emerald-600 px-3 py-2 text-white font-semibold shadow">
          TEST LECTOR
        </div>
        <div className="flex-1">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <h2 className="text-emerald-900 font-semibold">
              {formatDateLima(todayLima)} • {cohortLabel}
            </h2>
            <span className="text-sm text-emerald-800">
              Impulsado por <b>UGEL</b>
            </span>
          </div>

          <p className="mt-2 text-sm text-emerald-900/90">
            Completa las lecturas asignadas. Disponible hasta{" "}
            <b>{formatTimeLima(endLima)} (hora Perú)</b>.
          </p>

          <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-emerald-900/90">
            {[
              <>Encuentra un lugar <b>silencioso</b> y sin interrupciones.</>,
              <>Antes de empezar, realiza 3 ciclos de respiración <b>4–7–8</b>.</>,
              <>Lee <b>título</b>, luego el texto y después las preguntas.</>,
              <>Si una pregunta te toma mucho, continúa y vuelve al final.</>,
              <>Ten a la mano <b>agua</b> y evita distracciones.</>,
              <>Al terminar, revisa tus respuestas más dudosas.</>,
            ].map((content, i) => (
              <div
                key={i}
                className="flex items-start gap-3 rounded-lg border border-emerald-200 bg-emerald-50/60 p-3 shadow-sm"
              >
                <div className="mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full bg-emerald-600/90 text-white shrink-0">
                  <svg viewBox="0 0 24 24" fill="none" className="h-4 w-4" aria-hidden="true">
                    <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="leading-snug">{content}</div>
              </div>
            ))}
          </div>
        </div>

        <button
          onClick={() => setClosed(true)}
          className="ml-2 rounded-lg border border-emerald-200 px-2 py-1 text-emerald-700 hover:bg-emerald-100 text-sm"
          aria-label="Cerrar banner"
        >
          ✕
        </button>
      </div>
    </div>
  );
}

/** ======= Pantalla de cuenta regresiva previa ======= */
function CountdownScreen({ targetUtc, onDone }) {
  const slogans = useMemo(
    () => ["LECTURAS QUE FLORECEN", "LECTORES QUE CRECEN", "SUMAQTAI", "IMPULSADO POR UGEL"],
    []
  );

  const [now, setNow] = useState(Date.now());
  const [sloganIdx, setSloganIdx] = useState(0);
  const finishedRef = React.useRef(false);

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const t = setInterval(() => setSloganIdx((i) => (i + 1) % slogans.length), 2000);
    return () => clearInterval(t);
  }, [slogans.length]);

  const remainingSec = Math.max(0, Math.floor((targetUtc - now) / 1000));
  const mm = String(Math.floor(remainingSec / 60)).padStart(2, "0");
  const ss = String(remainingSec % 60).padStart(2, "0");

  useEffect(() => {
    if (!finishedRef.current && remainingSec <= 0) {
      finishedRef.current = true;
      const t = setTimeout(() => onDone?.(), 300);
      return () => clearTimeout(t);
    }
  }, [remainingSec, onDone]);

  return (
    <div className="min-h-[50vh] flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-2xl text-center">
        <div className="rounded-2xl border border-emerald-200 bg-white/70 shadow-sm p-6">
          <div className="text-xs uppercase tracking-wide text-emerald-700 font-semibold">
            SIGUIENTE GRUPO INICIA EN
          </div>
          <div className="mt-2 text-6xl sm:text-7xl font-bold tabular-nums text-emerald-900">
            {mm}:{ss}
          </div>
          <div className="mt-6">
            <div className="inline-block rounded-full px-4 py-1 text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200">
              {slogans[sloganIdx]}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/** ======= Card ======= */
const Row1 = memo(function Row1({ item, category }) {
  const styles = getCategoryStyles(category);

  let _tematica = "";
  if (category === "alumno") {
    _tematica = `autor: ${item.creator_alias} | Creación Literaria Estudiantil | `;
  }
  _tematica += item.tematica;

  return (
    <div
      key={item.id}
      onClick={() => (window.location.href = `/lecturas/${item.id}`)}
      className={`relative mb-4 break-inside-avoid overflow-hidden rounded-lg shadow-lg cursor-pointer transition-transform duration-300 hover:scale-105 hover:shadow-xl border-2 ${styles.borderColor}`}
    >
      <img
        src={`https://img-dinoblanco-shs.s3.amazonaws.com/album/${item.id}.jpg`}
        alt={item.titulo}
        className="w-full transition-transform duration-300"
        onError={(e) => {
          e.currentTarget.src =
            "https://img-dinoblanco-shs.s3.amazonaws.com/brand/sumaqtaiimagenotfound.jpg";
        }}
      />
      <div className="absolute top-0 left-0 w-full flex justify-between p-2">
        <span className="bg-white bg-opacity-75 text-xs text-gray-800 px-2 py-1 rounded-full shadow-sm">
          {_tematica}
        </span>
      </div>
      <div
        className={`absolute bottom-0 left-0 w-full ${styles.textColor} text-sm font-medium p-2 text-center transition-opacity duration-300 hover:bg-opacity-75 ${styles.titleBg} shadow-md`}
      >
        {item.titulo}
      </div>
    </div>
  );
});

/** ======= Grid ======= */
function ItemsGrid({ items, category }) {
  return (
    <div className="columns-2 sm:columns-2 md:columns-3 lg:columns-4 xl:columns-5 flex-nowrap gap-2 overflow-x-auto p-1 border rounded-lg">
      {items.map((it) => (
        <Row1 key={it.id} item={it} category={category} />
      ))}
    </div>
  );
}

/** ======= Tarjeta de grupo ======= */
function GroupInfoCard({ group, roleCategory }) {
  const items = useMemo(() => idsToItems(group.lecturas, group.tematica), [group.lecturas, group.tematica]);
  const start = new Date(group.startUtc);
  const end = new Date(group.endUtc);

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="mb-3">
        <h3 className="text-lg font-semibold text-slate-800">{group.label}</h3>
        <p className="text-sm text-slate-600">{group.description}</p>

        <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-slate-700">
          <div className="rounded-lg border bg-slate-50 p-3">
            <div className="font-medium">Hora de inicio</div>
            <div>{formatDateLima(start)} • {formatTimeLima(start)}</div>
          </div>
          <div className="rounded-lg border bg-slate-50 p-3">
            <div className="font-medium">Hora de fin</div>
            <div>{formatDateLima(end)} • {formatTimeLima(end)}</div>
          </div>
        </div>
      </div>

      <div className="mb-2 text-sm font-medium text-slate-700">
        Lecturas asignadas ({items.length})
      </div>

      <ItemsGrid items={items} category={roleCategory} />
    </section>
  );
}

/** ======= Componente principal ======= */
export default function FirstOrExam({ user, signOut }) {
  const [, forceRerender] = useState(0);

  const colegio = String(user?.attributes?.["custom:Colegio"] || "").trim();
  const zoneinfo = String(user?.attributes?.["zoneinfo"] || "").trim();
  const categoria = String(user?.attributes?.["custom:categoria_usuario"] || "").trim().toUpperCase();
  const gradoStr = String(
    user?.attributes?.["custom:Grado"] || user?.attributes?.["custom:grade"] || ""
  ).trim();
  const grado = Number(gradoStr) || NaN;

  const nowUTC = Date.now();
  const PRE_MS = 15 * 60 * 1000;

  const isDocente = categoria === "DOCENTE";
  const isAlumno = categoria === "ALUMNO";

  const userCtx = useMemo(
    () => ({
      colegio,
      zoneinfo,
      categoria,
      grado,
    }),
    [colegio, zoneinfo, categoria, grado]
  );

  /** Grupos que aplican exactamente al usuario */
  const matchedGroups = useMemo(() => {
    return TEST_GROUPS.filter((group) => matchGroup(group, userCtx));
  }, [userCtx]);

  /** Si el usuario tiene permiso de ver todas las secciones */
  const canSeeAllSections = useMemo(() => {
    return matchedGroups.some((g) => g.canSeeAllSections);
  }, [matchedGroups]);

  /** Grupos activos para el usuario */
  const activeGroupsForUser = useMemo(() => {
    return matchedGroups.filter((group) => {
      const start = Date.parse(group.startUtc);
      const end = Date.parse(group.endUtc);
      return nowUTC >= start && nowUTC <= end;
    });
  }, [matchedGroups, nowUTC]);

  /** Grupos en pre-ventana para el usuario */
  const preGroupsForUser = useMemo(() => {
    return matchedGroups.filter((group) => {
      const start = Date.parse(group.startUtc);
      return nowUTC >= start - PRE_MS && nowUTC < start;
    });
  }, [matchedGroups, nowUTC]);

  /** Si tiene acceso total, puede ver todos los grupos activos del sistema */
  const activeGroupsForAdmin = useMemo(() => {
    if (!canSeeAllSections) return [];

    return TEST_GROUPS.filter((group) => {
      if (group.canSeeAllSections) return false;
      const start = Date.parse(group.startUtc);
      const end = Date.parse(group.endUtc);
      return nowUTC >= start && nowUTC <= end;
    });
  }, [canSeeAllSections, nowUTC]);

  /** Pre-ventanas visibles para admin */
  const preGroupsForAdmin = useMemo(() => {
    if (!canSeeAllSections) return [];

    return TEST_GROUPS.filter((group) => {
      if (group.canSeeAllSections) return false;
      const start = Date.parse(group.startUtc);
      return nowUTC >= start - PRE_MS && nowUTC < start;
    });
  }, [canSeeAllSections, nowUTC]);

  /** Determinar countdown más cercano */
  const targetCountdownUtc = useMemo(() => {
    const candidates = [
      ...preGroupsForUser.map((g) => Date.parse(g.startUtc)),
      ...preGroupsForAdmin.map((g) => Date.parse(g.startUtc)),
    ];

    if (!candidates.length) return null;
    return Math.min(...candidates);
  }, [preGroupsForUser, preGroupsForAdmin]);

  const shouldShowCountdown =
    !activeGroupsForUser.length &&
    !activeGroupsForAdmin.length &&
    !!targetCountdownUtc;

  /** Qué grupos se renderizan */
  const groupsToRender = canSeeAllSections ? activeGroupsForAdmin : activeGroupsForUser;

  /** Hora máxima fin para banner */
  const endUtcForBanner = useMemo(() => {
    if (!groupsToRender.length) return null;
    return Math.max(...groupsToRender.map((g) => Date.parse(g.endUtc)));
  }, [groupsToRender]);

  const roleCategory = canSeeAllSections
    ? "plataforma"
    : isDocente
    ? "docente"
    : isAlumno
    ? "alumno"
    : "plataforma";

  /** Cuenta regresiva */
  if (shouldShowCountdown && targetCountdownUtc) {
    return (
      <div className="App">
        <HeaderCustomized
          nivel_estudiante={user.attributes["custom:Nivel"]}
          grade_estudiante={user.attributes["custom:grade"]}
          especialidad_usuario={user.attributes["custom:especialidad"]}
          categoria_usuario={user.attributes["custom:categoria_usuario"]}
          grado_estudiante={user.attributes["custom:Grado"]}
          colegio_usuario={user.attributes["custom:Colegio"]}
          username={user.attributes["given_name"]}
          zoneinfo={user.attributes["zoneinfo"]}
        />

        <CountdownScreen
          targetUtc={targetCountdownUtc}
          onDone={() => forceRerender((n) => n + 1)}
        />
      </div>
    );
  }

  /** Mostrar tests */
  if (groupsToRender.length > 0) {
    return (
      <div className="App">
        <HeaderCustomized
          nivel_estudiante={user.attributes["custom:Nivel"]}
          grade_estudiante={user.attributes["custom:grade"]}
          especialidad_usuario={user.attributes["custom:especialidad"]}
          categoria_usuario={user.attributes["custom:categoria_usuario"]}
          grado_estudiante={user.attributes["custom:Grado"]}
          colegio_usuario={user.attributes["custom:Colegio"]}
          username={user.attributes["given_name"]}
          zoneinfo={user.attributes["zoneinfo"]}
        />

        <div className="space-y-6 p-3">
          {endUtcForBanner && (
            <TestBanner
              endUtc={endUtcForBanner}
              cohortLabel={canSeeAllSections ? "Docentes / UGEL" : "Estudiantes"}
            />
          )}

          {groupsToRender.map((group) => (
            <GroupInfoCard
              key={group.id}
              group={group}
              roleCategory={roleCategory}
            />
          ))}
        </div>
      </div>
    );
  }

  /** Default */
  return (
    <div className="App">
      <HeaderCustomized
        nivel_estudiante={user.attributes["custom:Nivel"]}
        grade_estudiante={user.attributes["custom:grade"]}
        especialidad_usuario={user.attributes["custom:especialidad"]}
        categoria_usuario={user.attributes["custom:categoria_usuario"]}
        grado_estudiante={user.attributes["custom:Grado"]}
        colegio_usuario={user.attributes["custom:Colegio"]}
        username={user.attributes["given_name"]}
        zoneinfo={user.attributes["zoneinfo"]}
      />

      <div>
        <Cards
          grado_estudiante={user.attributes["custom:Grado"]}
          nivel_estudiante={user.attributes["custom:Nivel"]}
          categoria_usuario={user.attributes["custom:categoria_usuario"]}
          username={user.username}
        />
      </div>
    </div>
  );
}